// 用户中心-用户积分操作
const UserScoreRouterMap = [
  // 用户积分
  {
    path: '/user/score',
    component: Score => (require(['@/views/user/score'], Score))
  },
  // 用户积分转换
  {
    path: '/user/score-conversion',
    component: ScoreZhuan => (require(['@/views/user/scoreConversion'], ScoreZhuan))
  },
  // 用户积分兑换
  {
    path: '/user/score-exchange',
    component: ScoreDui => (require(['@/views/user/scoreExchange'], ScoreDui))
  }
]

export default UserScoreRouterMap



// WEBPACK FOOTER //
// ./src/router/modules/user/score.js